function getCookie(cookieName) {
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for(let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return "";
}

  // Función para establecer el valor de una cookie
function setCookie(cookieName, value) {
    const d = new Date();
    d.setTime(d.getTime() + (365*24*60*60*1000)); // Expira en 1 año
    const expires = "expires="+ d.toUTCString();
    document.cookie = cookieName + "=" + value + ";" + expires + ";path=/";
}


class GeolocationModal extends HTMLElement {
    constructor(){
        super()

        this.form = this.querySelector('form')
        this.submitForm = this.querySelector('.js-change-locale')
        this.selectLocale = this.querySelector('select')

        this.checkCurrentLocale()

        // this.submitForm.addEventListener("click", this.changeLocale.bind(this))
        this.addEventListener("click", this.checkOutsideClick.bind(this))
    }

    checkOutsideClick(event){
      console.log(!event.target.closest('.geolocation-popup__inner'))
      if(!event.target.closest('.geolocation-popup__inner')){
        this.classList.add("hidden")
        document.body.classList.remove('overflow-hidden')
      }
    }

    checkCurrentLocale(){
      fetch('browsing_context_suggestions.json')
      .then(res=>res.json())
      .then(response=>{
        const userCountry = response.detected_values.country.handle
        const selectedLocale = getCookie('localization')
        if(selectedLocale == userCountry){
          this.classList.add("hidden")
          document.body.classList.remove('overflow-hidden')
        }else{
          this.classList.remove("hidden")
          document.body.classList.add('overflow-hidden')
        }
      })
      // else{
      //   const options = this.selectLocale.options
      //   for(const option of options){
      //     console.log(option.value)
      //     if(option.dataset.selectedLocale == selectedLocale){
      //       //window.location.href = option.value
      //     }
      //   }
      // }
    }

    changeLocale(){
      console.log("geolocation", this.selectLocale.options[this.selectLocale.selectedIndex].dataset.selectedLocale)
      
      const selectedUrl = this.selectLocale.value.replace("https://", "")
      if(selectedUrl != window.location.host){
        setCookie("geolocation", this.selectLocale.options[this.selectLocale.selectedIndex].dataset.selectedLocale)
        window.location.href = this.selectLocale.value
      }else{
        setCookie("geolocation", this.selectLocale.options[this.selectLocale.selectedIndex].dataset.selectedLocale)
        this.checkCurrentLocale()
      }
    }
}
customElements.define("geolocation-modal", GeolocationModal)

  